import { useState, useEffect } from "react";
import { useUsersImageRetrieve } from "@/api/generated/backendAPI";
import { FaCamera } from "react-icons/fa";

type Props = {
  userId: string;
  noImageType: "noimage" | "" | undefined;
  size: number;
};

function UserImage(props: Props) {
  const { userId, noImageType, size } = props;
  const { data, isLoading} = useUsersImageRetrieve(userId)
  const [imageURL, setImageURL] = useState("");

  useEffect(() => {
    if(!isLoading){
      if(data){
        const objURL = URL.createObjectURL(data);
        setImageURL(objURL)
      }
    }
  }, [isLoading, data]);

  useEffect(() => {
    return () => {
      if(imageURL){
        URL.revokeObjectURL(imageURL)
      }
    }
  })


  return (
    <>
      {!isLoading && imageURL ? (
        <div className={`size-${size} rounded-full overflow-hidden`}>
          <img src={imageURL} className="object-cover min-w-full" />
        </div>
      ) : (
        noImageType === "noimage" && (
          <div className={`flex flex-col items-center justify-center size-${size} text-xs`}>
            <FaCamera size="40%" />
            <span>NO IMAGE</span>
          </div>
        )
      )}
    </>
  );
}

export default UserImage;
